import React from 'react'
import { Box, Button } from '@mui/material'

const TaskTabToggle = ({ 
  activeTab, 
  onTabChange, 
  tabs = [
    { value: 'tasks', label: 'Tasks' },
    { value: 'work-planner', label: 'Work Planner' }
  ]
}) => {
  return (
    <Box display="flex" justifyContent="center" mb={4}>
      <Box
        sx={{
          display: 'flex',
        //   bgcolor: '#f3f4f6', // light gray background
          borderColor: 'e5e5e5', // light line border
          borderRadius: '50px', // fully rounded
          border: '1px solid transparent', 
          minWidth: 320,
        }}
      >
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.value
          const isFirst = index === 0
          const isLast = index === tabs.length - 1
          
          // Calculate border radius based on position
          let borderRadius = '50px' // default full radius
          
           if (isActive) {
            // ACTIVE TAB: Rounded on outer edge, flat on inner edge
            if (isFirst) {
              borderRadius = '50px 0 0 50px' // rounded LEFT, flat RIGHT
            } else if (isLast) {
              borderRadius = '0 50px 50px 0' // flat LEFT, rounded RIGHT
            } else {
              borderRadius = '0' // no radius if in middle
            }
          } else {
            // INACTIVE TAB: Opposite of active tab
            if (isFirst) {
              borderRadius = '50px 0 0 50px' // rounded LEFT, flat RIGHT
            } else if (isLast) {
              borderRadius = '0 50px 50px 0' // flat LEFT, rounded RIGHT
            }
          }

          return (
            <Button
              key={tab.value}
              sx={{
                bgcolor: isActive ? '#FDF6E2' : 'transparent', // light yellow when active
                color: isActive ? 'dark-text.main' : 'dark-text.main',
                border: isActive ? '1px solid #F3BF3A' : '1px solid #e5e5e5', // dark yellow border when active
                borderRadius: borderRadius,
                px: 2,
                py: 1,
                textTransform: 'none',
                // fontWeight: isActive ? 600 : 500, // bolder when active
                minWidth: 160,
                fontSize: '14px',
                '&:hover': {
                  bgcolor: isActive ? '#FDF6E2' : 'rgba(0,0,0,0.04)',
                },
              }}
              onClick={() => onTabChange(tab.value)}
            >
              {tab.label}
            </Button>
          )
        })}
      </Box>
    </Box>
  )
}

export default TaskTabToggle